import { TagDot } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { CTAEnticerBannerContent } from "../CTAEnticerBanner/CTAEnticerBannerContent";

import React, { type RefObject } from "react";
import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  tagDot: {
    marginTop: 1,
    marginRight: 4,
  },
});

export type InterviewNowCTAEnticerProps = {
  interviewerCount: number;
  onFirstImpression: () => void;
  hasLoggedImpression: RefObject<boolean>;
};

export const InterviewNowCTAEnticerBannerContent: React.FC<InterviewNowCTAEnticerProps> = ({
  interviewerCount = 1,
  onFirstImpression,
  hasLoggedImpression,
}) => {
  const i18n = useI18n();

  const enticerText = i18n.ngettext(
    // # Helper text - Lets the jobseeker know how many recruiters are available online to interview now.
    "{0} recruiter online to interview",
    "{0} recruiters online to interview",
    interviewerCount,
    interviewerCount.toString(),
  );

  return (
    <CTAEnticerBannerContent
      hasLoggedImpression={hasLoggedImpression}
      onFirstImpression={onFirstImpression}
      text={enticerText}
      icon={<TagDot sx={styles.tagDot} aria-hidden status="success" />}
    />
  );
};
